import memoize from 'lodash/memoize';
import { trackAutoEvent, track } from '../../vendor/splitmetrics-track';



export const EVENT_NAME = 'comment_view';


export default memoize((index = 0, fullScreen = false, auto = false) => {
  const props = { full_screen: fullScreen, comment_index: index, comment_id: index };

  if (auto) {
    trackAutoEvent(EVENT_NAME, props);
  } else {
    track(EVENT_NAME, props);
  }
}, (...args) => args.join(','));



// WEBPACK FOOTER //
// ./src/lib/track-event/comment-view.js